// import React, { useState } from "react";
// import Modal from "react-bootstrap/Modal";
// import "../view-detail/view-detail.css";
// import Tooltip from "@mui/material/Tooltip";
// import ATImage from "../assets/images/AT.png";
// import DTImage from "../assets/images/DT.png";
// import LTImage from "../assets/images/LT.png";
// import MTImage from "../assets/images/MT.png";
// import NTImage from "../assets/images/NT.png";

// function ShowModal(details) {
//   const userData = details.details.data;
//   const usersName = details?.details?.data.username;
//   const assignedAsset = userData?.assignedasset
//     .split(",")
//     .filter((item) => item.trim() !== "");
//   const hasAssignedAssets = assignedAsset.length > 0;
//   return (
//     <Modal
//       centered
//       className="modal fade show"
//       {...details}
//       size="lg"
//       aria-labelledby="contained-modal-title-vcenter"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title
//           id="contained-modal-title-vcenter"
//           className=" !text-lg uppercase"
//         >
//           Asset Assigned
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="">
//         <div className="">
//           <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
//             {hasAssignedAssets ? (
//               // Render assets if there are any
//               assignedAsset.map((value, index) => {
//                 let imageName = value.includes("F") ? value.split("F")[1]?.substring(0, 2) : "";
//                 let imageSrc;

//                 switch (imageName) {
//                   case "AT": imageSrc = ATImage; break;
//                   case "DT": imageSrc = DTImage; break;
//                   case "LT": imageSrc = LTImage; break;
//                   case "MT": imageSrc = MTImage; break;
//                   case "NT": imageSrc = NTImage; break;
//                   default: imageSrc = null; break;
//                 }

//                 return (
//                   <li
//                     className="bg-[#c6f8e9] h-[38px] w-auto flex justify-center items-center gap-x-4 rounded-md hover:scale-[1.1] transition-all duration-300 text-center"
//                     key={index}
//                   >
//                     {imageSrc && (
//                       <img className="h-[22px] w-[22px] hidden md:block" src={imageSrc} alt={value} />
//                     )}
//                     <span>{`${index + 1}. ${value}`}</span>
//                   </li>
//                 );
//               })
//             ) : (
//               // Render the "no asset" message when there are no assets
//               <li
//                 className="bg-[#c6f8e9] h-[38px] w-auto flex justify-center items-center rounded-md hover:scale-[1.1] transition-all duration-300 text-center whitespace-nowrap "
//                 key={0}
//               >
//                 <span className="font-medium capitalize mr-[2px]">
//                   {usersName}
//                 </span>{" "}
//                 not having any assigned assets
//               </li>
//             )}
//           </ul>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// }

// function ViewAsset(data) {
//   const [modalShow, setModalShow] = React.useState(false);

//   // const [details, setDetails] = useState(props)
//   //   const [loading, setLoading] = useState(false)

//   // useEffect(()=>{
//   //   getDetails();
//   // },[])

//   return (
//     <>
//       <Tooltip title="Asset Detail" placement="top" arrow>
//         <div
//           className="kr-tbl-view cursor-pointer action-item"
//           onClick={() => setModalShow(true)}
//         >
//           <span className="svg-icon">
//             <svg x="0px" y="0px" viewBox="0 0 700 700">
//               <g>
//                 <path
//                   d="M671,321.2C635.5,277,507.5,131.6,350,131.6S64.6,277,29.1,321.2c-10,12.7-10,30.8,0,43.5C64.6,409.6,192.6,555,350,555
//                                        S635.5,409.6,671,365.4C680.3,352.7,680.3,333.9,671,321.2L671,321.2z M350,482.7c-77,0-139.4-63-139.4-139.4S273,204,350,204
//                                        s139.4,63,139.4,139.4C489.4,420.4,427.1,482.7,350,482.7z"
//                 ></path>
//               </g>
//             </svg>
//           </span>
//         </div>
//       </Tooltip>

//       <ShowModal
//         details={data}
//         show={modalShow}
//         onHide={() => setModalShow(false)}
//       />
//     </>
//   );
// }

// export default ViewAsset;
import React from "react";
import Modal from "react-bootstrap/Modal";
import "../view-detail/view-detail.css";
import Tooltip from "@mui/material/Tooltip";
import ATImage from "../assets/images/AT.png";
import DTImage from "../assets/images/DT.png";
import LTImage from "../assets/images/LT.png";
import MTImage from "../assets/images/MT.png";
import NTImage from "../assets/images/NT.png";

function Field({ label, value, colorClass }) {
  return (
    <div>
      <div className="font-bold mb-1 text-[13px] text-gray-900">{label}:</div>
      <input
        type="text"
        className={`kr-view-field ${colorClass || ""}`}
        value={value ?? ""}
        readOnly
        onFocus={(e) => e.target.select()}
      />
    </div>
  );
}

function ShowModal(details) {
  const userData = details.details.data;
  const usersName = userData?.username;

  const yesNo = (val) => (val ? "Yes" : "No");

  const assignedAsset = userData?.assignedasset
    ? userData.assignedasset.split(",").filter((item) => item.trim() !== "")
    : [];
  const hasAssignedAssets = assignedAsset.length > 0;

  return (
    <Modal
      centered
      className="modal fade show"
      {...details}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton className="border-b border-gray-200 pb-3">
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="!text-[18px] font-bold text-gray-900 truncate"
          title={`Employee Details: ${userData?.empid || ""}`}
        >
          Employee Details: {userData?.empid}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-6 pt-3 pb-5">

        {/* ── Employee Info grid ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-3 pointer-events-none">

          <Field label="Employee Name" value={userData?.username || "---"} />
          <Field label="Employee ID" value={userData?.empid || "---"} />
          <Field label="Designation" value={userData?.designation || "---"} />
          <Field label="Department" value={userData?.department || "---"} />
          <Field label="Email" value={userData?.email || "---"} />

          {/* <Field
            label="Is Active"
            value={yesNo(userData?.isactive)}
            colorClass={userData?.isactive ? "kr-view-field-success" : "kr-view-field-danger"}
          /> */}

          <Field
            label="CPU Assigned"
            value={yesNo(userData?.iscpuassigned)}
            colorClass={userData?.iscpuassigned ? "kr-view-field-success" : "kr-view-field-danger"}
          />

          <Field
            label="Laptop Assigned"
            value={yesNo(userData?.islaptopassigned)}
            colorClass={userData?.islaptopassigned ? "kr-view-field-success" : "kr-view-field-danger"}
          />

          <Field
            label="Monitor Assigned"
            value={yesNo(userData?.ismonitorassigned)}
            colorClass={userData?.ismonitorassigned ? "kr-view-field-success" : "kr-view-field-danger"}
          />

          <Field
            label="Rental Laptop Assigned"
            value={yesNo(userData?.isrentallaptopassigned)}
            colorClass={userData?.isrentallaptopassigned ? "kr-view-field-success" : "kr-view-field-danger"}
          />

        </div>

        {/* ── Divider ── */}
        <hr className="border-gray-200 mt-3 mb-3" />

        {/* ── Assigned Assets ── */}
        <p className="text-[13px] font-bold text-gray-900 mb-2">Assigned Assets</p>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {hasAssignedAssets ? (
            assignedAsset.map((value, index) => {
              let imageName = value.includes("F")
                ? value.split("F")[1]?.substring(0, 2)
                : "";
              let imageSrc;
              switch (imageName) {
                case "AT": imageSrc = ATImage; break;
                case "DT": imageSrc = DTImage; break;
                case "LT": imageSrc = LTImage; break;
                case "RE": imageSrc = LTImage; break;
                case "MT": imageSrc = MTImage; break;
                case "NT": imageSrc = NTImage; break;
                default: imageSrc = null; break;
              }
              return (
                <li
                  key={index}
                  className="bg-[#c6f8e9] h-[38px] w-auto flex justify-center items-center gap-x-4 rounded-md text-center hover:bg-[#a0f0d8] hover:shadow-md transition-colors duration-200"
                >
                  {imageSrc && (
                    <img
                      className="h-[22px] w-[22px] hidden md:block"
                      src={imageSrc}
                      alt={value}
                    />
                  )}
                  <span>{`${index + 1}. ${value}`}</span>
                </li>
              );
            })
          ) : (
            <li className="bg-[#c6f8e9] h-[38px] w-auto flex justify-center items-center rounded-md text-center col-span-2 whitespace-nowrap">
              <span className="font-medium capitalize mr-[2px]">{usersName}</span>{" "}
              not having any assigned assets
            </li>
          )}
        </ul>

      </Modal.Body>
    </Modal>
  );
}

function ViewAsset(data) {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <Tooltip title="Asset Detail" placement="top" arrow>
        <div
          className="kr-tbl-view cursor-pointer action-item"
          onClick={() => setModalShow(true)}
        >
          <span className="svg-icon">
            <svg x="0px" y="0px" viewBox="0 0 700 700">
              <g>
                <path
                  d="M671,321.2C635.5,277,507.5,131.6,350,131.6S64.6,277,29.1,321.2c-10,12.7-10,30.8,0,43.5C64.6,409.6,192.6,555,350,555
                   S635.5,409.6,671,365.4C680.3,352.7,680.3,333.9,671,321.2L671,321.2z M350,482.7c-77,0-139.4-63-139.4-139.4S273,204,350,204
                   s139.4,63,139.4,139.4C489.4,420.4,427.1,482.7,350,482.7z"
                ></path>
              </g>
            </svg>
          </span>
        </div>
      </Tooltip>

      <ShowModal
        details={data}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default ViewAsset;